const types = ['carpool']

const frequencies = ['once', 'daily', 'continuously']

const redemptionStatuses = ['requested', 'approved', 'rejected']

module.exports = { types, frequencies, redemptionStatuses }
